module.exports = __webpack_public_path__ + "static/media/watch-icon.00a4b1bf.svg";